import { parseDict } from '@/util/dicts'
import Info from './info'
import global from '@/util/mixin/global'

//审批状态：0、已提交(审核中)；1、已通过；2、已拒绝；3、已取消
const statusIcon = [
  {value:0,label:'processing'},
  {value:1,label:'success'},
  {value:2,label:'error'},
  {value:3,label:'default'},
]

export default {
  props: ['carNo','raw'],
  mixins:[global],
  data() {
    return {
      columns: [
        {
          title: '提交时间',
          key: 'createDatetimeText',
          minWidth: 160,
        },
        {
          title: '提交人',
          key: 'creator',
          minWidth: 120,
        },
        
        {
          title: '审核状态',
          key: 'applyStatusText',
          minWidth: 120,
          render:(h , { row })=>{
            // 
            return <div>
              <sl-badge title={row.applyStatusText} style={{'marginRight':'6px'}} status={row.applyStatusIcon} />
              <span>{row.applyStatusText}</span>
            </div>
          }
        },
        {
          title: '审核人',
          key: 'modifier',
          minWidth: 120
        },
        {
          title: '审核时间',
          key: 'modifyDatetimeText',
          minWidth: 160,
        },
        {
          title: '操作',
          key: 'action',
          width: 120,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let acts = [
              <a on-click={()=>this.view(row)}>查看</a>
            ]
            if( row.first ){
              return <span>新建信息</span>
            }
            else {
              return this.$utils.link(acts, <Divider type="vertical" />)
            }
          }
        }
      ],
      data: [],
      loading: false,
    }
  },

  created() {
    this.$watch('carNo' , function(nv){
      this.data = []
      if(nv){
        this.query()
      }
    },{immediate:true})
  },

  methods: {
    review(){
      
    },
    query(){
      this.$request.carChangelog(this.carNo).then(resp => {
        this.loading = false
        if (!resp.code) {
          let raw = this.raw || {}
          this.data = (this.$utils.conv(resp.data || [], {'createDatetime':'datetime', 'applyStatus': 'carReviewState' , 'modifyDatetime':'datetime' , 'applyStatus:applyStatusIcon':statusIcon}))

          //.concat([{createDatetimeText:raw.createDatetimeText , creator:raw.creator, first:true}])
        }
      })
    },
    view(row , review = false) {
      this.$dialog({
        title: '车辆变更详情',
        fullscreen:true,
        paddingless: true,
        render: (h) => {
          return <Info reviewable={false} data={row} />
        },
      })
    },

    handleUpdate() {

    },

  },
  render() {
    return (
      <div class="pg-bd">
        <sl-table showHeader={true} loading={this.loading} page={false} columns={this.columns} data={this.data}>
        </sl-table>
      </div>
    )
  }
}
